import { RESET_RANDOMIZATION_HYPOTHESIS_TESTING } from '../types';
import { APPEND_SAMPLES, SET_SAMPLES, RESET_SAMPLES } from './types';

import { RESET_DATASET } from 'store';

export default (state = [], action) => {
  switch (action.type) {
    case SET_SAMPLES:
      return action.samples;

    case APPEND_SAMPLES:
      return [...state, ...action.samples];

    case RESET_DATASET:
    case RESET_SAMPLES:
    case RESET_RANDOMIZATION_HYPOTHESIS_TESTING:
      return [];

    default:
      return state;
  }
};
